module.exports = __webpack_public_path__ + "img/projects_banner.e05cc0fb.png";